import { EntityName } from 'record-it-time-common/EntityName';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useConstructionSiteDeleteHandler(constructionSite) {
  return useEntityDeleteHandler(EntityName.ConstructionSite, constructionSite, _temp);
}
function _temp(site) {
  return site.name;
}